<button
  type="button"
  [disabled]="disabled()"
  (click)="onClick()"
  [ngClass]="{
    'cursor-pointer active:opacity-90': config().action,
    'opacity-50 cursor-not-allowed': disabled(),
    'aspect-video': config().variant === 'front',
  }"
  class="relative overflow-hidden flex bg-cover bg-center rounded-(--digitalcredentialcard-border-radius) max-w-(--digitalcredentialcard-max-width) mx-auto shadow-(--digitalcredentialcard-shadow) w-full font-(--digitalcredentialcard-font-family) bg-(image:--digitalcredentialcard-background-gradient)"
>
  <div class="flex flex-col h-full gap-4 px-(--digitalcredentialcard-padding-x) py-(--digitalcredentialcard-padding-y)">
    @if (config().logoIcon) {
      <app-dynamic
        componentName="SvgIcon"
        [props]="{
          name: config().logoIcon,
          size: '38',
          color: 'var(--digitalcredentialcard-content-color)',
        }"
      />
    }

    @switch (config().variant) {
      @case ("back") {
        @if (config().title) {
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: config().title,
                size: '2xl',
                fontWeight: 'semibold',
                color: 'var(--digitalcredentialcard-content-color)',
              },
            }"
          />
        }

        <div class="flex flex-col gap-4 mt-8">
          @for (field of config().fields; track $index) {
            <div class="flex flex-col gap-1">
              <app-dynamic
                componentName="DynamicText"
                [props]="{
                  config: {
                    text: field.label,
                    size: 'sm',
                    fontWeight: 'bold',
                    color: 'var(--digitalcredentialcard-content-color)',
                  },
                }"
              />
              <app-dynamic
                componentName="DynamicText"
                [props]="{
                  config: {
                    text: field.value,
                    size: 'xl',
                    fontWeight: 'semibold',
                    color: 'var(--digitalcredentialcard-content-color)',
                  },
                }"
              />
            </div>
          }
        </div>
      }
      @default {
        <div class="flex flex-col gap-1 mt-auto">
          @for (line of config().lines; track $index) {
            <app-dynamic
              componentName="DynamicText"
              [props]="{
                config: {
                  text: line,
                  size: 'sm',
                  fontWeight: 'bold',
                  color: 'var(--digitalcredentialcard-content-color)',
                },
              }"
            />
          }
        </div>
      }
    }
  </div>
</button>
